export default "<app-contact-panel [contact]=\"contact\"></app-contact-panel>"